<div class="gallery-section">

  <div class="gallery-header">
    <p class="gallery-title">{{translationsService.translate('WebGalis_Gallery')}}</p>
    <a class="gallery-view-all" href="#">Vse slike →</a>
  </div>

  <div class="gallery-grid">
    @for (gridItem of data; track gridItem) {
      <div class="gallery-item" (click)="itemClick(gridItem)">
        <a [href]="gridItem.Url" target="_blank">
          @for (column of activeBindings; track column) {
            @if (column.includes('Media')) {
              <sem-image-viewer [height]="300" [width]="400"
              [mediaId]="dfms.getValue(gridItem,column)"></sem-image-viewer>
            }
            @if (!column.includes('Media')) {
              <p class="grid-title">{{dfms.getValue(gridItem,column)}}</p>
            }
          }
        </a>
      </div>
    }
  </div>

</div>

<ng-content></ng-content>
